import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  const painPoints = ["You haven't showered alone in weeks.", 'You feel anxious before every nap.', "You're stuck on the couch for hours.", 'Every transfer fails.', 'You love your baby… but you feel completely trapped.'];
  return <section id="validation" className="relative pt-12 pb-8 md:pt-20 md:pb-12 px-6 md:px-8 bg-cream-dark overflow-hidden" data-id="element-684">
      {/* Subtle ambient glow */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-terracotta/4 rounded-full blur-[120px] pointer-events-none" data-id="element-685" />

      <div className="max-w-2xl mx-auto relative" data-id="element-686">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="text-center mb-12 md:mb-14" data-id="element-687">
          {/* Ornamental divider */}
          <div className="flex items-center justify-center gap-3 mb-5" data-id="element-688">
            <div className="w-8 md:w-12 h-px bg-gradient-to-r from-transparent to-brown/10" data-id="element-689" />
            <div className="w-1.5 h-1.5 rounded-full bg-terracotta/30" data-id="element-690" />
            <div className="w-8 md:w-12 h-px bg-gradient-to-l from-transparent to-brown/10" data-id="element-691" />
          </div>
          <h2 className="font-serif text-3xl md:text-5xl text-brown leading-tight" data-id="element-692">
            If This Is You…
          </h2>
        </motion.div>

        {/* Pain points — editorial style */}
        <div className="space-y-0 mb-14 md:mb-16 max-w-lg mx-auto" data-id="element-693">
          {painPoints.map((pain, i) => {
          const isLast = i === painPoints.length - 1;
          return <motion.div key={i} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.07,
            ease: [0.25, 0.1, 0.25, 1]
          }} className={`relative pl-6 py-4 ${!isLast ? 'border-b border-brown/[0.04]' : ''}`} data-id="element-694">
                {/* Left accent line */}
                <div className="absolute left-0 top-4 bottom-4 w-[2px] rounded-full" style={{
              background: isLast ? 'linear-gradient(180deg, rgba(198,114,76,0.4), rgba(198,114,76,0.15))' : 'linear-gradient(180deg, rgba(61,50,41,0.08), rgba(61,50,41,0.03))'
            }} data-id="element-695" />
                <span className={`font-serif text-lg md:text-xl leading-relaxed ${isLast ? 'text-brown font-medium italic' : 'text-brown/75 font-normal'}`} data-id="element-696">
                  {pain}
                </span>
              </motion.div>;
        })}
        </div>

        {/* Closing card */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.7,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="relative max-w-lg mx-auto" data-id="element-697">
          <div className="relative rounded-2xl md:rounded-3xl p-8 md:p-10 text-center border border-brown/[0.06] overflow-hidden" style={{
          background: 'linear-gradient(160deg, #FFFFFF 0%, #FAF7F2 100%)',
          boxShadow: '0 4px 24px rgba(61,50,41,0.04), 0 16px 48px rgba(61,50,41,0.06)'
        }} data-id="element-698">
            {/* Warm top glow */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-2/3 h-24 pointer-events-none" style={{
            background: 'radial-gradient(ellipse at top, rgba(198,114,76,0.06) 0%, transparent 70%)'
          }} data-id="element-699" />
            {/* Decorative quote mark */}
            <span className="block font-serif text-5xl text-terracotta/15 leading-none mb-3 select-none" data-id="element-700">
              "
            </span>

            <p className="font-serif text-lg md:text-xl text-brown/80 leading-relaxed mb-1" data-id="element-701">
              You're not failing.
            </p>
            <p className="font-serif text-lg md:text-xl text-brown leading-relaxed font-medium" data-id="element-702">
              You're just missing a structure that protects{' '}
              <span className="text-terracotta italic" data-id="element-703">you</span>.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}